import { ReactNode, useEffect } from "react"
import { useAppSelector } from "../../redux/store/hooks"
import { selectDashboardSelectedValueType } from "../../redux/ProfessionalDashboard"
import { useLocation, useNavigate } from "react-router-dom"
import {
    NAVIGATION_VIEW,
    NavigationPaths
} from "../../navigation/NavigationController"
import {
    mockPhqValueTypeUsed,
    mockSleepValueTypeUsed,
    selectOnboardingIsRunningState,
    selectOnboardingStep
} from "../../redux/Onboarding"

interface RequireValueTypeSelectionProps {
    children: ReactNode
}

function RequireValueTypeSelection(props: RequireValueTypeSelectionProps) {
    const valueType = useAppSelector(selectDashboardSelectedValueType)
    const navigate = useNavigate()
    const location = useLocation()

    const running = useAppSelector(selectOnboardingIsRunningState)
    const step = useAppSelector(selectOnboardingStep)

    useEffect(() => {
        if (
            valueType === null &&
            !mockPhqValueTypeUsed(running, step) &&
            !mockSleepValueTypeUsed(running, step)
        ) {
            navigate(
                NavigationPaths[NAVIGATION_VIEW.PATIENT_SELECTION_VIEW].path
            )
        }
    }, [valueType, location])

    return <>{props.children}</>
}

export default RequireValueTypeSelection
